module.exports = __webpack_public_path__ + "static/src/content/logos/google.27ec84a.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/logos/google.png
// module id = AwJa
// module chunks = 1